import EurekaSearchResults from 'ui-theme/widgets/search-result/_search-result.js';
import Multi from '../../ts/_multi-inherit';
import Base from '../../ts/_base';

class Share extends Multi(EurekaSearchResults, Base) {
    constructor(share) {
        super(share);
        this.hideClear();
    }
    protected get childSelctors(): { [key: string]: string } {
        return {
            'clear': '.a2a_kit'
        }
    }
    protected hideClear() {
        // Callback function to execute when mutations are observed
        const clear = this.queryElm(this.childSelctors.clear) as HTMLElement;
        // Options for the observer (which mutations to observe)
        const config = { attributes: false, childList: true, subtree: true };

        const callback = (mutationList, observer) => {
            mutationList[0].addedNodes[0].ariaHidden = true
        };

        const observer = new MutationObserver(callback);
        observer.observe(clear, config);
    }
}

export default Share;
